//TO DO: should be moved to @types/payment-panel pkg with language list
export enum PaymentPanelV2EventName {
  Initialize = 'initialize',
  Initialized = 'initialized',
  PaymentAttempt = 'processing',
  Authorize = 'authorize',
  Authorizing = 'authorizing',
  PaymentMethodChanged = 'payment_method_changed',
  PaymentMethodAction = 'payment_method_action',
  InstallmentPlanChanged = 'installment_plan_changed',
  PaymentCustomMetric = 'payment_custom_metric',
  ChangeOrderData = 'changeOrderData',
  SingleStepCheckoutPayNowClicked = 'singleStepCheckoutPayNowClicked',
  SingleStepOrderDetailsUpdated = 'singleStepOrderDetailsUpdated',
  CheckoutStateChanged = 'checkoutStateChanged',
  ChangeLanguage = 'changeLanguage',
  ClearAllSubscriptions = 'clearAllSubscriptions',
  GiftCardOrderSummary = 'giftCardOrderSummary',
  Authorization = 'authorization',
  EmbeddedReload = 'embedded_reload'
}

export enum PaymentPanelOrigin {
  Checkout = 'ESW Checkout Evo',
  Payment = 'ESW Payments'
}

export interface PaymentPanelV2Event<T> {
  eventName?: PaymentPanelV2EventName;
  origin?: PaymentPanelOrigin;
  eventData?: T;
}

export interface I18nPaymentEventData {
  localized_text: { [key: string]: string };
}

export interface InitializeEventData {
  authorization_confirmation?: boolean;
  culture?: string;
  i18n?: I18nPaymentEventData;
  fraudData?: unknown;
  profile_token?: string;
  style?: {
    paymentPanelThemeUrl?: string;
    cardPanelThemeUrl?: string;
    cssVariablesList?: { [key: string]: string };
    cardPanelFontUrls?: string[];
    paymentPanelFontUrls?: string[];
    paymentPanelLayout?: 'vertical' | 'horizontal';
  };
  isSingleStepCheckout?: boolean;
  paymentId?: string;
  isMFE?: boolean;
  orderId?: string;
  isRudderstack?: boolean;
  isEmbeddedCheckout?: boolean;
  targetOrigin?: string;
  showCheckboxForTermsAndConditions?: boolean;
  fullRedirectFlowDisabled?: boolean;
  isCheckoutComposable?: boolean;
}

export interface ChangeLanguageEventData {
  culture: string;
  i18n: I18nPaymentEventData | null;
  termsAndConditionsUrl?: string;
  privacyPolicyUrl?: string;
}

export interface AuthorizationEventData {
  status: 'success' | 'failed';
  eswCode?: string;
}
